export default __webpack_public_path__ + "static/media/77t.0a62332e.jpg";